import { matchPath } from './match-path';
export default (path, currentPath) => {
    const linkPath = path === '/' ? '/home' : path;
    const windowPath = currentPath === '/' ? '/home' : currentPath;
    return matchPath(windowPath, linkPath);
};
//# sourceMappingURL=is-path-selected.js.map